import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import { i18n } from './utils/i18n'

const app = createApp(App)

app.config.globalProperties.$t = (key) => i18n.t(key)
app.config.globalProperties.$i18n = i18n

app.use(router).mount('#app')
